import { render, staticRenderFns } from "./phone-input.pug?vue&type=template&id=27225a63&lang=pug&external"
import script from "./phone-input.js?vue&type=script&lang=js&external"
export * from "./phone-input.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports